export default {
  dashboards: [],
  selectedDashboard: [],
  selectedDashboardToken: {}
}
